/* URL ROUTER */
var Router = function (route,params) {
    //parametre
    if (typeof(params) == 'object') {
        var p = '';
        $.each(params,function (name,value) {
            if (p != '') {
                p += '&';
            }
            p += escape(name)+'='+escape(value);
        });
        return Router(route)+'?'+p;
    }
    else {
        return '/' + route;
    }
};
Router.route = function (route,params) {
    var url = Router(route,params);
    location.href = url;
}
$(function(){
    var absoluteFeedback = $('#absoluteFeedback');
    absoluteFeedback.on('mouseenter', function(){
        $('#absoluteFeedback').addClass('show');
    }).on('mouseleave', function(){
        $('#absoluteFeedback').removeClass('show');
    });
});

/* Plugin na input hint */
jQuery.fn.inputHint = function () {
    this.each(function () {
        var self = $(this);
        if (self.is('input[type=text]')) {
            jQuery.inputHintShow(self);
            self.focus(function () {
                jQuery.inputHintHide(this);
            }).blur(function () {
                jQuery.inputHintShow(this);
            }).closest('form').submit(function () {
                jQuery.inputHintHide(self);
                return true;
            });
        }
    });
    return this;
};
jQuery.inputHintShow = function (inpt) {
    inpt = jQuery(inpt);
    if (inpt.val() == inpt.attr('title') || inpt.val() == '') {
        inpt.addClass('hint').val(inpt.attr('title'));
    }
}
jQuery.inputHintHide = function (inpt) {
    inpt = jQuery(inpt);
    inpt.removeClass('hint');
    if (inpt.val() == inpt.attr('title')) {
        inpt.val('');
    }
}

//plugin na zebra tabulky a highlight tabulky
jQuery.fn.zebraTable = function () {
    this.each(function () {
        var self = $(this);
        if (self.is('table')) {
            $('tbody tr:even',self).removeClass('even').addClass('odd');
            $('tbody tr:odd',self).removeClass('odd').addClass('even');
        }
    });
    return this;
};
jQuery.fn.highlightTable = function () {
    this.each(function () {
        var self = $(this);
        if (self.is('table')) {
            self.off('mouseover.highlight').on('mouseover.highlight', 'tbody tr',function () {
                $('>td',this).addClass('highlight');
            });
            self.off('mouseout.highlight').on('mouseout.highlight', 'tbody tr',function () {
                $('>td',this).removeClass('highlight');
            });
        }
    });
    return this;
};

//plugin na cookies
jQuery.cookie = function(name, value, options) {
    if (typeof value != 'undefined') { // name and value given, set cookie
        options = options || {};
        if (value === null) {
            value = '';
            options = $.extend({}, options); // clone object since it's unexpected behavior if the expired property were changed
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
        }
        // NOTE Needed to parenthesize options.path and options.domain
        // in the following expressions, otherwise they evaluate to undefined
        // in the packed version for some reason...
        var path = options.path ? '; path=' + (options.path) : '';
        var domain = options.domain ? '; domain=' + (options.domain) : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else { // only name given, get cookie
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};

/* Plugin na formulare */
jQuery.fn.disableForm = function() {
    this.each(function () {
        var t = $(this);
        if (t.is('form')) {
            t.find('input,select,textarea,button').prop('disabled',true);
        } else if (t.is('input,select,textarea,button')) {
            t.prop('disabled',true);
        }
    });
    return this;
};
jQuery.fn.enableForm = function() {
    this.each(function () {
        var t = $(this);
        if (t.is('form')) {
            t.find('input,select,textarea,button').removeProp('disabled');
        } else if (t.is('input,select,textarea,button')) {
            t.removeProp('disabled');
        }
    });
    return this;
};

/* Produktovy karusel */
jQuery.fn.productCarousel = function (userParams) {
    var params = $.extend({
        itemMargin: 0,
        animationDuration: 750,
        moveBy: 0,
        updateHeight: false,
        auto: false
    }, userParams);
    this.each(function () {
        var $panel = $(this);
        var container = $panel.find('.productCarousel');
        if (!params.moveBy) {
            var moveBy = container.data('moveby');
            if (!moveBy) moveBy = 4;
            params.moveBy = moveBy;
        }
        var content = $panel.find('.productCarouselContent');
        var items = $panel.find('.carouselItem');
        if (items.length) {
            var itemw = items.eq(0).outerWidth() + params.itemMargin; //+margin
            if (params.updateHeight) {
                var itemh = items.eq(0).outerHeight();
                items.each(function () {
                    var h = $(this).outerHeight();
                    if (h > itemh) {
                        itemh = h;
                    }
                });
            } else {
                itemh = container.height();
            }
            var containerw = container.width();
            var contentw = items.length * itemw;
            //o kolko sa ma animacia posuvat
            var posun = itemw * params.moveBy;
            //nastavime vysku kontaineru (kazdy item ma rovnaku sirku)
            container.height(itemh);
            content.width(contentw).height(itemh).css({
                position: 'absolute',
                top: '0px',
                left: '0px'
            });
            //nastavime triggre
            //zapocitame aj paddingy
            contentw -= params.itemMargin;
            $panel.find('.arrowRight').data('disabled', 0).on('click.carousel', function () {
                var curleft = parseInt(content.css('left'));
                if (Math.abs(curleft) + containerw < contentw) {
                    var finishLeft = Math.max(curleft - posun, -contentw + containerw);
                    content.animate({
                        left: finishLeft + 'px'
                    },{
                        duration: params.animationDuration,
                        complete: function () {
                            //disable right arrow
                            if (finishLeft == (-contentw + containerw)) {
                                $panel.find('.arrowRight').data('disabled', 1).addClass('arrowRightDisabled');
                            }
                        }
                    });
                    //enable left arrow
                    $panel.find('.arrowLeft').data('disabled', 0).removeClass('arrowLeftDisabled');
                }
                return false;
            });
            $panel.find('.arrowLeft').data('disabled', 1).addClass('arrowLeftDisabled').on('click.carousel', function () {
                var curleft = parseInt(content.css('left'));
                if (curleft < 0) {
                    var finishLeft = Math.min(curleft + posun, 0);
                    content.animate({
                        left: finishLeft + 'px'
                    },{
                        duration: params.animationDuration,
                        complete: function () {
                            //disable left arrow
                            if (finishLeft == 0) {
                                $panel.find('.arrowLeft').data('disabled', 1).addClass('arrowLeftDisabled');
                            }
                        }
                    });
                    //enable right arrow
                    $panel.find('.arrowRight').data('disabled', 0).removeClass('arrowRightDisabled');
                }
                return false;
            });
        }
    });
    return this;
};

//bannerAnimation
bannerAnimation = function (element) {
    this.banners = $(element);
    this.bannerItems = this.banners.find('li');
    this.animationDuration = 1000;
    this.defaultBannerDuration = 7000;
    this.activeIdx = 0;
    this.bannersTimeout = null;
    this.updateHeight = false;
    this.createProgressBar = true;
    this.progressbar = this.banners.find('.progressbar');
    this.autoMove = true;//ak sa nastavi na false, bannery prestanu rotovat
}
bannerAnimation.prototype.setAutoMove = function (status) {
    this.autoMove = status;
    //zrusime timeout
    if (!this.autoMove && this.bannersTimeout) {
        window.clearTimeout(this.bannersTimeout);
        this.bannersTimeout = null;
    }
}
bannerAnimation.prototype.displayNextBannersItem = function (init, itemidx) {
    var self = this;
    //zaktualizujeme vysku kontainera
    if (init && this.updateHeight) {
        var h = this.banners.height();
        $.each(this.bannerItems, function (idx, el) {
            h = Math.max($(el).height(), h);
        });
        this.banners.height(h);
    }
    if (this.bannerItems.length > 1) {
        var bannerItemCur = this.banners.find('li').eq(this.activeIdx);
        var duration = 0;
        if (init) {
            duration = parseInt(bannerItemCur.find('input[name=duration]').val());
            if (!duration) {
                duration = this.defaultBannerDuration;
            }
            //vytvorime progressBar
            if (this.createProgressBar && this.progressbar.length) {
                this.progressbar.show();
                var progressItem = null;
                for (var i = 0 ; i < this.bannerItems.length ; i++) {
                    progressItem = $('<a href="javascript:void(0);"></a>');
                    progressItem.addClass('item');
                    if (i == 0) {
                        progressItem.addClass('item-active');
                    }
                    progressItem.html('<span>' + (i+1) + '</span>');
                    progressItem.click(function () {
                        self.displayNextBannersItem.call(self, false, $(this).index());
                        //zrusime automaticke rotovanie
                        self.setAutoMove.call(self, false);
                    });
                    this.progressbar.append(progressItem);
                }
            }
            if (this.autoMove) {
                this.bannersTimeout = window.setTimeout(function () {
                    self.displayNextBannersItem(false);
                }, duration + this.animationDuration);
            }
        } else {
            if (typeof(itemidx) == 'number') {
                var nextItem = this.bannerItems.eq(itemidx);
                if (this.bannersTimeout) {
                    window.clearTimeout(this.bannersTimeout);
                    this.bannersTimeout = null;
                }
            } else {
                var nextItem = bannerItemCur.next('li');
            }
            if (nextItem.length == 0) {
                nextItem = this.banners.find('li:first');
            }
            this.activeIdx = nextItem.index();
            //skryjeme aktualny banner
            bannerItemCur.fadeOut(this.animationDuration);
            duration = parseInt(nextItem.find('input[name=duration]').val());
            if (!duration) {
                duration = this.defaultBannerDuration;
            }
            if (self.updateHeight) {
                self.banners.height(Math.max(self.banners.height(), nextItem.height()));
            }
            //zobrazime dalsi banner
            nextItem.fadeIn(this.animationDuration, function () {
                if (self.autoMove) {
                    self.bannersTimeout = window.setTimeout(function () {
                        self.displayNextBannersItem(false);
                    }, duration + self.animationDuration);
                }
            });
            //zobrazime bodku
            if (this.createProgressBar && this.progressbar.length) {
                this.progressbar.find('.item')
                    .removeClass('item-active')
                    .eq(this.activeIdx)
                        .addClass('item-active');
            }
        }
    }
}

/**
 *  Plugin na vycentrovanie objektu
 *  navratová hodnota je samotny objekt
 */
jQuery.fn.centerObject = function (fixed) {
    return this.each(function () {
        var object = jQuery(this);
        object.css({
            position: fixed ? 'fixed' : 'absolute',
            left:     '50%',
            top:      '50%'
        }).css({
            marginTop:  '-' + (object.outerHeight() / 2) + 'px',
            marginLeft: '-' + (object.outerWidth() / 2) + 'px'
        });

        if (!fixed) {
            object.css({
                marginTop: parseInt(object.css('marginTop'), 10) + jQuery(window).scrollTop(),
                marginLeft: parseInt(object.css('marginLeft'), 10) + jQuery(window).scrollLeft()
            });
        }
    });
};

getHighestZIndex = function() {
    var maxZ = 0;
    $('*').each(function() {
        var z = parseInt($(this).css('z-index'), 10);
        if (!isNaN(z) && z !== 2147483647 && z > maxZ) {
            maxZ = z;
        }
    });
    return maxZ;
};

jQuery.fn.popupInfo = function (settings){

    settings = $.extend({
       width: 500,
       top: 0,
       overlay: true,
       timeout: 0,
       closeImg: '/public/themes/images/close.png'
    },settings);

    return this.each(function(){
        var self = $(this);
        var overlay;
        if(settings.overlay){
            overlay = $('<div id="overlay"></div>').css({
                "z-index": getHighestZIndex()+1
            });
            overlay.show().click(function(){
                self.remove();
                overlay.remove();
            });
        }

        self.append('<div class="report__close"></div>')
            .hide()
            .fadeIn(500);

        if (settings.overlay) {
            $('body').append(overlay);
        }
        $('body').append(self);
        self.css({
            "z-index": getHighestZIndex()+1
        });

        $(self).on('click','.report__close',function(){
            if ( $('#eshopCart').length && $(this).hasClass('button') ) {
               location.reload();
            }
            $(self).trigger('close');
        });

        $(self).on('close', function(){
            self.remove();
            if(settings.overlay){
                overlay.remove();
            }
        });

        if (settings.timeout) {
            setTimeout(function() {
                self.fadeOut(1000,function(){
                    self.remove();
                });
                if(settings.overlay){
                    overlay.fadeOut(1000,function(){
                        overlay.remove();
                    });
                }
            }, settings.timeout);
        }

    });
};

jQuery.fn.popupDialog = function(settings){

    settings = $.extend({
        width: 300,
        height: 100,
        loadUrl: '',
        reloadOnSuccess: true,
        loaded: function(dialog){ },
        success: function(dialog){ },
        create: function(dialog){ }
    }, settings);

    return this.each(function(){
        var target = $(this);
        target.click(function(e){
            e.preventDefault();

            var dialog = $('<div></div>').appendTo($('body'));
            dialog.dialog({
                modal:     true,
                autoOpen:  false,
                width:     settings.width,
                minHeight: settings.height,
                title:     target.attr('title'),
                close:     function () {
                    dialog.remove();
                },
                create: function(event, ui) {
                    settings.create(dialog);
                }
            });

            if(target.is('a')){
                settings.loadUrl = target.attr('href');
            }

            dialog.load(settings.loadUrl, function () {

                var form = $('form', dialog);
                form.submit(function (e) {
                    e.preventDefault();

                    var submitBtn = $('button',form).attr('disabled','disabled');

                    form.loading();
                    $.post(form.attr('action'), form.serialize(), function (response) {
                        if (response.status == 'OK') {
                            if(settings.reloadOnSuccess) {
                                location.reload();
                            }
                            showReport(response.message, 'OK');
                            dialog.dialog("close");

                            settings.success(response);
                        } else if(response.status == 'DELETED'){
                            window.location = window.location.pathname + window.location.hash;
                            showReport(response.message, 'OK');
                            dialog.dialog("close");

                            settings.success(response);
                        } else {
                            showReport(response.message, 'ERROR');
                            submitBtn.removeAttr('disabled');
                            form.loading('hide');
                        }
                    }, 'JSON');
                });

                settings.loaded(dialog);
                dialog.dialog("open");
                dialog.dialog("option", "position", "center");
            });
        });
    });
};

jQuery.fn.loading = function(actionOrOptions){

    var options = $.extend({
        className: 'loading loading-24',
        bgColor: '#FFF'
    }, actionOrOptions);

    return this.each(function(){
        var self = this;

        if(actionOrOptions == 'hide'){
            if (self.loading !== undefined){
                self.hideLoading();
            }
        } else {

            $(self).css('position', 'relative');

            self.loading = $('<div></div>').addClass(options.className).css({
                opacity: 0.5,
                width:   $(self).outerWidth(),
                height:  $(self).outerHeight(),
                position: 'absolute',
                'background-color': options.bgColor,
                top: 0,
                left: 0
            });

            self.showLoading = function(){
                self.loading.remove().appendTo($(self));
            }

            self.hideLoading = function(){
                self.loading.remove();
            }

            self.showLoading();
        }
    });
};

/**
 * Plugin na nastavenie rovnakych výšok v elemente
 */
$.fn.sameHeight = function(options){

    options = $.extend({
        selector: '.col',
        minWidth: 0
    }, options);

    return this.each(function(){
        var $this = $(this);
        var $items = $this.find(options.selector);

        var self = this;

        self.calculate = function(){
            if ($(window).width() >= options.minWidth) {
                self.height = 0;
                self.offset = null;
                self.row = [];

                $items.height('auto');
                $items.each(function(){
                    var item = $(this);

                    if (self.offset !== null && self.offset != item.offset().top) {
                        for(i in self.row) {
                            self.row[i].height(self.height);
                        }

                        self.row = [];
                        self.height = 0;
                    }

                    if (item.height() > self.height) {
                        self.height = item.height();
                    }

                    self.offset = item.offset().top;
                    self.row.push(item);
                });

                if (self.row.length) {
                    for(i in self.row) {
                        self.row[i].height(self.height);
                    }
                }

            } else {
                $items.height('auto');
            }
        };

        self.calculate();
        $(window).on('resize', function(){
            self.calculate();
        });

    });
};

/****************************************************************************
*   TABBER
*****************************************************************************/
$.fn.taber = function () {
    this.each(function () {
        var self = $(this);
        self.find('.tabsMenu ul li a').click(function () {
            var s = $(this);
            self.find('.tabsMenu ul li').removeClass('active');
            s.closest('li').addClass('active');

            self.find('.tabsContent .tabsPanel').hide();
            self.find(s.attr('href')).show();
            return false;
        });
    });
    return this;
}

/****************************************************************************
*   STYLISH SELECT
*****************************************************************************/
jQuery.fn.selectbox = function (params) {

    var params = $.extend({
        selected : function(selectbox){
            return false;
        }
    }, params);

    this.each(function () {

        var selectbox = $(this);
        var selecter = selectbox.next('.selecter');
        selecter.appendTo('body');

        selectbox.on('click', function(){
            $('div.selecter').each(function(){
                if($(this)[0] != selecter[0]){
                    $(this).hide();
                }
            });
            selecter.css({
                top: selectbox.offset().top + selectbox.outerHeight(),
                left: selectbox.offset().left
            });
            selecter.toggle();
        });

        selecter.on('click', 'a', function(){
            var self = $(this);
            $('a', selecter).removeClass('selected');
            self.addClass('selected');

            $('input', selectbox).val(self.attr('rel'));
            $('span', selectbox).html(self.html());

            selecter.hide();

            params.selected(selectbox);
        });
    });

    $('body').on('click', function(event){
         var self = $(event.target);
         if(self.is('span')){
             self = self.parent();
         }
         if(!self.hasClass('selecter') && !self.hasClass('selectbox')){
             $('div.selecter').hide();
         }
    })

    return this;
};

function priceFormat(p, decimals) {
    var ps = "" + (Math.round(p * 100) / 100).toFixed(2);
    return ps.replace('.',',');
}

/* Overlay */
function blockOverlay(block) {
    if (typeof block != 'object') {
        $('.blockOverlay').remove();
    } else {
        if ($('.blockOverlay').length) {
            return false;
        }
        var overlay = $('<div />').addClass('blockOverlay');
        overlay.css('width', block.outerWidth(true));
        overlay.css('height', block.outerHeight(true));
        overlay.css('top', block.position().top);
        overlay.css('left', block.position().left);
        overlay.css('opacity', '0.6');
        overlay.appendTo(block);
        overlay.fadeTo(200, 0.7);
        return true;
    }
}

function blockOverlayRemove(block) {
    $('.blockOverlay', block).remove();
}

$(function() {

    // AJAX ERROR
    // $(document).ajaxError(function (request, settings, e) {
    //     alert('Error requesting URL: '+e.url);
    // });

    const scrollPosition = localStorage.getItem('scrollPosition');
    const urlParams = new URLSearchParams(window.location.search);
    const shouldOffset = urlParams.get('offset');
    if (shouldOffset > 0 && scrollPosition == null) {
        const subheader = $('.category__subheader');
        if (subheader.length > 0) {
            let offset = subheader.offset().top - 250;
            if (offset < 0) offset = 0;
            $(window).scrollTop(offset);
        }
    }
    if (scrollPosition !== null) {
        $(window).scrollTop(parseInt(scrollPosition, 10));
        localStorage.removeItem('scrollPosition');
    }

    //animacia bannerov na hlavnej stranke
    $('#mainBanner').each(function () {
        var b = new bannerAnimation($(this));
        b.displayNextBannersItem(true);
    });

	//hinty vo formularoch
	$('input.hint').inputHint();

	//vypnut autocomplete vo formularoch
	$('input.autocompleteoff').attr('autocomplete','off');

	//zebra tabulky + highlight
    $('table.zebra').zebraTable();
    $('table.highlight').highlightTable();

    //topprodukty carousel
    $('#topproducts-container').productCarousel({
        itemMargin: 1
    });

    //hodnotenie produktov
    $('div.rating-container').hover(function () {
        $(this).addClass('rating-container-hover');
    }, function () {
        $(this).removeClass('rating-container-hover');
    });
    $('div.rating-container a.rate').click(function () {
        var rating = $(this).closest('div.rating-container').find('div.rating');
        var progress = $(this).closest('div.rating-container').find('div.rating-progress');
        progress.css('opacity',0.7);
        progress.show();
        $.getJSON(this.href, function (result) {
            progress.fadeOut();
            if (result.rating) {
                rating.css('width', (result.rating * 100) + '%');
            }
        })
        return false;
    });

    //zobrazenie externych RSS feedov
    window.setTimeout(function () {
        $('div.rss-feed').each(function () {
            var self = $(this);
            self.load(WEBROOT + '/system/load-feed/',{
                    feed: self.data('feedurl'),
                    count: self.data('items-count')
            });
        });
        $('div.rss-feed a').click(function () {
            window.open(this.href);
            return false;
        })
    }, 200);

    // REPORTY V POPUP OKNE
    showReports();

    //taber
	$('.tabs').taber();

	//hlavne menu s popup kategoriami
    //vytvorime si pole s popupKategoriami
    var popupCategories = $('#topCategoriesBlock div.popupCategories');
    popupCategories.hide().appendTo('body');

    var menuHideTimeout = null;
    var popupCategoriesItems = $('#topCategoriesBlock ul li.category');
    popupCategoriesItems.on('menushow', function () {
        //skryjeme najprv vsetky ostatne //pre istotu
        popupCategoriesItems.trigger('menuhide', { force:true });

        //zobrazime aktualnu
        var tab = $(this);
        tab.addClass('hover');

        var popup = null;
        popupCategories.each(function(){
            var self = $(this);
            if(self.hasClass(tab.attr('id'))){
                popup = self;
            }
        });

        if(popup){
            //nastavime aj spravnu polohu
            var pos = $('#topCategoriesBlock').offset();
            popup.css({
                left: pos.left,
                top: pos.top + $('#topCategoriesBlock').outerHeight()
            });
            popup.fadeIn('fast');
        }

        //nastavime event na skrytie
        $('body').on('mousemove.categoryPopups', function (event) {
            var target = $(event.target);
            var isTargetted = (target == popup)
                || (target.closest(popup).length ? true : false)
                || (target == tab)
                || (target.closest(tab).length ? true : false);
            if (!isTargetted) {
                tab.data('preventMenuHide', 0);
                tab.trigger('menuhide');
                // menuHideTimeout = window.setTimeout(function () {
                //     tab.trigger('menuhide');
                // }, 50);
            } else {
                tab.data('preventMenuHide', 1);
            }
        });

    }).on('menuhide', function (event, data) {
        var tab = $(this);
        if (tab.data('preventMenuHide') == 1 && !data.force) {
            if (menuHideTimeout) {
                window.clearTimeout(menuHideTimeout);
                menuHideTimeout = null;
            }
            return;
        }
        tab.removeClass('hover');
        popupCategories.each(function(){
            var self = $(this);
            if(self.hasClass(tab.attr('id'))){
                self.hide();
            }
        });
        $('body').off('mousemove.categoryPopups');
    }).on('mouseenter', function () {
        $(this).trigger('menushow');
    });

    //price range slider
    var pricerangeSlider = $('#searchPriceRange');
    if (pricerangeSlider.length) {
        var pricerangeMax = pricerangeSlider.data('max');
        var pricerangeMin = pricerangeSlider.data('min');
        //zaokruhlime nadol a nahor na cele desiatky
        pricerangeMax = Math.ceil(pricerangeMax / 10) * 10;
        pricerangeMin = Math.floor(pricerangeMin / 10) * 10;
        pricerangeSlider.slider({
            range: true,
            min: pricerangeMin,
            max: pricerangeMax,
            step: 1,
            values: [$('#searchPriceMin').val() || pricerangeMin, $('#searchPriceMax').val() || pricerangeMax],
            create: function () {
                $(this).find('a.ui-slider-handle:eq(0)').addClass('ui-slider-handle-from');
                $(this).find('a.ui-slider-handle:eq(1)').addClass('ui-slider-handle-to');
            },
            slide: function(event, ui) {
                searchPriceRangeDisplay(ui.values[0], ui.values[1]);
                $('#searchPriceMin').val(ui.values[0] <= pricerangeMin ? '' : ui.values[0]);
                $('#searchPriceMax').val(ui.values[1] >= pricerangeMax ? '' : ui.values[1]);
            },
            stop: function () {
                //pricerangeSlider.closest('form').submit();
            }
        });

        function searchPriceRangeDisplay(v1, v2) {
            var ammin = $("#searchPriceRangeAmountMin");
            var ammax = $("#searchPriceRangeAmountMax");
            var t = '';
            ammin.text(v1 + ammin.data('currency'));
            ammax.text(v2 + ammax.data('currency'));
            //pozicia
            ammin.css('left', ((v1 - pricerangeMin) / (pricerangeMax - pricerangeMin) * 100) + '%');
            ammax.css('left', ((v2 - pricerangeMin) / (pricerangeMax - pricerangeMin) * 100) + '%');
        }
        searchPriceRangeDisplay(pricerangeSlider.slider("values", 0), pricerangeSlider.slider("values", 1));
    }

    // stylish select pre pager a pager options k produktom
	$('#selectboxLimit, #selectboxSort, #selectboxPager').on('change', function(e){
        e.preventDefault();
        var selectbox = $(this);
        var oldLimit = parseInt(selectbox.data('oldlimit') || 0, 10);
        if(oldLimit && oldLimit < selectbox.val()){
            localStorage.setItem('scrollPosition', window.scrollY);
        } else {
            var offset = 0;
            var subheader = $('.category__subheader');
            if (subheader.length > 0) {
                offset = subheader.offset().top - 150;
                if (offset < 0) offset = 0;
            }

            localStorage.setItem('scrollPosition', offset);
        }
        window.location.href = selectbox.data('baseurl') + selectbox.val();
    });

    $('#selectboxBrand').selectbox({
        selected: function (selectbox) {
            $('#catalogSearchForm').submit();
            return true;
        }
    });

    function checkScrollArrow($wrapper) {
        if (!$wrapper.is(':visible')) return;

        var scrollHeight = $wrapper[0].scrollHeight;
        var clientHeight = $wrapper[0].clientHeight;
        var scrollTop = $wrapper.scrollTop();

        var $arrowDown = $wrapper.children('.scroll-arrow-down');
        var $arrowUp = $wrapper.children('.scroll-arrow-up');

        if (scrollHeight > clientHeight) {
            // Zobraz dole keď nie sme na úplnom spodku
            if (scrollTop + clientHeight >= scrollHeight - 1) {
                $arrowDown.hide();
            } else {
                $arrowDown.css('display', 'flex');
            }

            // Zobraz hore keď nie sme úplne hore
            if (scrollTop <= 1) {
                $arrowUp.hide();
            } else {
                $arrowUp.css('display', 'flex');
            }
        } else {
            $arrowDown.hide();
            $arrowUp.hide();
        }
    }

    function setupDropdown($trigger, $dropdown) {
        var $scrollWrapper = $dropdown.children('.header__dropdown-scroll-wrapper');
        var showTimer;
        var hideTimer;

        function openDropdown() {
            clearTimeout(hideTimer);
            $dropdown.show();
            $trigger.attr('aria-expanded', 'true');
            $scrollWrapper.children('.scroll-arrow-up, .scroll-arrow-down').hide();
            requestAnimationFrame(function() { checkScrollArrow($scrollWrapper); });
        }

        function scheduleClose() {
            clearTimeout(showTimer);
            hideTimer = setTimeout(function () {
                $dropdown.hide();
                $trigger.attr('aria-expanded', 'false');
            }, 650);
        }

        $trigger.on('mouseenter', function () {
            clearTimeout(hideTimer);
            showTimer = setTimeout(openDropdown, 300);
        });

        $trigger.on('mouseleave', scheduleClose);


        $scrollWrapper.on('scroll', function () {
            checkScrollArrow($scrollWrapper);
        });
    }

    $('.header__desktop-nav-item').each(function () {
        var $item = $(this);
        var $dropdown = $item.find('.header__desktop-nav-dropdown').first();
        if ($dropdown.length) {
            setupDropdown($item, $dropdown);
        }
    });

    $('.li--arrow').each(function () {
        var $item = $(this);
        var $submenu = $item.find('.header__desktop-nav-dropdown--second').first();
        if ($submenu.length) {
            setupDropdown($item, $submenu);
        }
    });

    $('div.tooltip, a.tooltip').tooltip();

    var absoluteMail = $('#absoluteMail');
    var absoluteMailForm = $('#absoluteMailForm');

    if(absoluteMail.length) {
        if(absoluteMailForm.length) {
            absoluteMail.on('click', function (event) {
                event.preventDefault();

                var resetBoxs = absoluteMailForm.find('div.block:not(.block-submit)');
                resetBoxs.find('input.text, textarea').text('').val('');
                resetBoxs.find(':checkbox').attr('checked', false);
                absoluteMailForm.find('input, textarea').removeClass('missing');

                absoluteMailForm.popupInfo({
                    top: 100
                });

                var form = absoluteMailForm.find('form');
                form.submit(function(e) {
                    e.preventDefault();
                    var self = $(this);

                    form.loading();
                    $.ajax({
                        url: self.attr('action'),
                        type: "POST",
                        data: self.serialize(),
                        success: function (response) {
                            if (response.status == 'ERROR') {
                                self.find('input, textarea').each(function() {
                                    var input  = $(this);
                                    input.removeClass('missing');
                                    $.each( response.missing, function( index, value ){
                                        if(input.hasClass(value)) {
                                            input.addClass('missing');
                                        }
                                    });
                                });
                                report(response.message, 'ERROR');
                            } else {
                                absoluteMailForm.trigger('close');
                                report(response.message, 'OK');
                            }
                        },
                        error: function (xhr) {
                            report(xhr.responseText, 'ERROR');
                        },
                        complete: function () {
                            form.loading('hide');
                        },
                        global: false,
                        dataType: 'json'
                    });
                });
            });

        } else {
            absoluteMail.hide();
        }
    }

    var popup = $('#popup');
    if (popup.length) {
        popup.on('click', '.popup-close', function () {
            popup.remove();
        });
    }

    $('body').on('click', 'a.product-ecommerce', function(e){
        var target = $(this);

        if (typeof dataLayer !== 'undefined' && target.data('id') && target.data('name')) {
            e.preventDefault();
            e.stopPropagation();

            dataLayer.push({
                'event': 'productClick',
                'ecommerce': {
                    'click': {
                        'actionField': {'list': target.data('list') },
                        'products': [{
                            'name': target.data('name'),
                            'id': target.data('id'),
                            'price': target.data('price'),
                            'brand': target.data('brand'),
                            'category': target.data('category'),
                            'variant': target.data('variant'),
                            'position': target.data('position')
                        }]
                    }
                },
                'eventCallback': function() {
                    document.location = target.attr('href');
                }
            });
        }
    });

    let countrySelect = $('select.country-select');
    if (countrySelect.length) {
        $('body').on('change', 'select.country-select', function(e, skip = false){
            let select = $(this);
            let country = $(":selected", select).data('country');
            let countryCode = select.val();

            $('input.country', select.parent()).val(country);
            if (select.closest('#invoiceAddressSection').length && $('#deliveryAddressIsEqual').is(':checked')) {
                let deliveryAddressSection = $('#deliveryAddressSection');
                $('select.country-select', deliveryAddressSection).val(select.val()).trigger('change');
                $('input.country', deliveryAddressSection).val(country);
            }

            let selector = '#deliveryAddressSection';

            if(select.closest('#invoiceAddressSection').length) {
                selector = '#invoiceAddressSection';
            }

            let ro = $('.form-col__ro', selector);
            let nonRo = $('.form-col__nonro', selector);
            if(countryCode === 'RO') {
                ro.show();
                nonRo.hide();
                $('input, select', ro).removeAttr('disabled');
                $('input, select', nonRo).attr('disabled', 'disabled');
            } else {
                ro.hide();
                nonRo.show();
                $('input, select', ro).attr('disabled', 'disabled');
                $('input, select', nonRo).removeAttr('disabled');
            }
            $('#zip').attr('maxlength', $(':selected', countrySelect).data('zip_length'));
            $('body').trigger('deliveryAddressToggleDisable');
            countrySelect.trigger('deliveryCountryCheck');
        }).on('change', '#deliveryAddressIsEqual', function() {
            countrySelect.trigger('change');
        }).on('deliveryCountryCheck', function() {
            let countrySelect = $('.select.country-select', $('#invoiceAddressSection'));
            let pcountrySelect = $('.select.country-select', $('#deliveryAddressSection'));

            $('.delivery-country-warning', countrySelect.parent()).css('display', pcountrySelect.val() !== pcountrySelect.data('lang') && $('#deliveryAddressIsEqual').is(':checked') ? 'block' : 'none');
            $('.delivery-country-warning', pcountrySelect.parent()).css('display', pcountrySelect.val() !== pcountrySelect.data('lang') ? 'block' : 'none');
        });
        countrySelect.trigger('change', true);
        //countrySelect.trigger('deliveryCheck', countrySelect);
    }

    let dCountrySelect = $('#deliveryAddressSection select.country-select');
    if(dCountrySelect.length) {
        $('body').on('change', '#deliveryAddressSection select.country-select', function(e, skip = false){
            let select = $(this);
            let country = $(":selected", select).data('country');
            let countryCode = $(":selected", select).val();

            let processing = $('#processing');
            if (processing.length) {
                processing.show();
            }
            var dp = $('#summaryDeliveryPrice');
            var dd = $('#summaryDeliveryDiscount');
            var tp = $('#summaryTotalPrice');

            $('#dzip').attr('maxlength', $(':selected', dCountrySelect).data('zip_length'));

            $.getJSON(LANGROOT + '/eshop/order/calculate-country-delivery/', {
                country_code: countryCode,
                country: country,
            }, function (resp) {
                if (processing.length) {
                    processing.hide();
                }

                if(resp.deliveryInfo && resp.deliveryInfo !== '') {
                    $('.amount', dp).text(resp.deliveryInfo);
                    $('.currency', dp).hide();
                } else if (resp.delivery) {
                    $('.amount', dp).text(priceFormat(resp.delivery));
                    $('.currency', dp).show();
                    if (dd.length) {
                        $('.amount', dd).text(priceFormat(resp.delivery));
                    }

                    if (resp.hasDeliveryFreeGiftCard) {
                        let price = resp.delivery;
                        if (price > 0) {
                            price = -1 * price;
                        }

                        $('.amount', dd).text(priceFormat(price));
                        dd.show();
                    }

                } else {
                    $('.amount', dp).text(priceFormat(0));
                    $('.currency', dp).show();
                    if (dd.length) {
                        dd.hide();
                    }
                }

                $('.amount', tp).text(priceFormat(resp.totalOrderPrice));
            });
        });
        dCountrySelect.trigger('change', true);
    }

    //rocny date picker
    /*$('.dp-year').datepicker({
        dateFormat: "yy"
    });*/
});

/****************************************************************************
 * TOOLTIP
 ****************************************************************************/
jQuery.fn.tooltip = function (params) {

    var params = $.extend({
        selected : function(selectbox){
            return false;
        }
    }, params);

    this.each(function () {

        var tooltip = $(this);
        var tooltipData = tooltip.find('.tooltip-data');
        tooltipData.appendTo('body');

        tooltip.hover(function(){

            var w = $(window);

            var left = tooltip.offset().left;
            if(w.width() < left + tooltipData.outerWidth()){
                left = w.width() - tooltipData.outerWidth() - 20;
            }

            tooltipData.css({
                display: 'block',
                top: tooltip.offset().top + tooltip.outerHeight() + 10 + 'px',
                left: left + 'px'
            });
        },function(){
            tooltipData.hide();
        });
    });

    return this;
};

function addReport(message, type){
    var reports = $('#reports');
    if(!reports.length){
        reports = $('<div id="reports"></div>').appendTo($('body'));
        reports.css({'z-index': getHighestZIndex()+1});
    }

    reports.append(
        '<div class="report">' +
        '<span class="ico ico-' + type + '">&#160;</span>' +
        message +
        '</div>'
    );
}

function showReport(message, type){
    addReport(message, type);
    showReports();
}

function showReports(){
    var reports = $('#reports');
    if ($('.ico-OK',reports).length){
        reports.popupInfo({
            top: 200,
            timeout: 3000
        });
    } else {
        reports.popupInfo({
            top: 200
        });
    }
    // Toto vynúti správne prekrytie
    reports.css('z-index', getHighestZIndex()+1);
}

function report(msg , type){
    var reports = $('#reports');
    if(!reports.length){
        reports = $('<div/>').attr('id','reports').appendTo($('body'));
    }

    reports.html(
        '<div class="report report-' + type.toUpperCase() + '">' +
            '<span class="ico ico-' + type.toUpperCase() + '"> </span>' +
            msg +
        '</div>'
    );
    reports.popupInfo({
        top: 200
    });
    return reports;
}

String.prototype.translate = function() {
    if (typeof locale != 'undefined' && typeof locale[this] != 'undefined') {
        return locale[this];
    } else {
        return this;
    }
};

function __(msg){
    return msg.translate();
}

jQuery.fn.addToCart = function (params) {

    var params = $.extend({
        success : function(form){ },
        complete : function(){ }
    }, params);

    this.each(function () {

        var form = $(this);
        var popup = $('<div class="cartAddPopupCase"></div>');

        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: form.serialize(),
            beforeSend: function(){

                if ($('#overlay').length) {
                    $('#overlay').remove();
                }

                if ($('div.cartAddPopupCase').length) {
                    $('div.cartAddPopupCase').remove();
                }

                popup.hide();
                popup.popupInfo({
                    overlay: true,
                    width: 786
                })
                .html('<div class="cartAddPopupLoading"></div>');
            },
            success: function(response){
                popup.html(response).centerObject();
                popup.on('click', '.close', function() {
                    popup.trigger('close');
                    location.reload();
                });

                if ($('div.products-alternative-popup', popup).length) {
                    const carouselAlternativePopup = new Carousel(document.querySelector("div.products-alternative-popup"), {
                        fill: true,
                        infinite: false,
                        center: false,
                        Dots: false,
                        Navigation: false,
                        Autoplay: false,
                        wheel: false,
                    });
                }

                var error = $(response).find('div.report');
                if (!error.length) {

                    $.getJSON(LANGROOT + '/eshop/cart/info/', function (response) {
                        var headerCart = $('#headerCart');
                        if (headerCart.length) {
                            var badge = $('.badge', headerCart);
                            if (badge.length) {
                                badge.text(response.count);
                                if (response.count > 0) {
                                    badge[0].style.display = 'flex';
                                } else {
                                    badge[0].style.display = 'none';
                                }
                            }

                            $('.count', headerCart).text(response.count);
                            $('.price', headerCart).text(response.price);

                            var cartContainer = $(".header__cart-preview");
                            cartContainer.empty();
                            var translations = {
                                sk: "Spolu s DPH: &#160;",
                                cz: "Celkem včetně DPH: &#160;",
                                hu: "Bruttó végösszeg: &#160;",
                                ro: "Total cu TVA: &#160;"
                            };

                            var lang = $("html").attr("lang") || "sk";

                            var footer = $("<div>", {
                                class: "header__cart-preview-footer",
                                html: translations[lang] || translations["sk"]
                            });
                            var items = $("<div>", { class: "header__cart-preview-items"});
                            var totalPrice = $("<strong>", { class: "price", text: response.price + " " + response.currency });
                            cartContainer.append(items);
                            footer.append(totalPrice);
                            cartContainer.append(footer);

                            var cartItemsContainer = $(".header__cart-preview-items");
                            cartItemsContainer.empty();

                            response.items.forEach(function (data) {
                                var cartItem = $("<div>", { class: "header__cart-preview-item" });
                                var cartInfo = $("<div>", { class: "cart-preview-info" });
                                var productImage = $("<img>", { src: data.photoUrl, alt: "product icon" });
                                var productLink = $("<a>", { href: data.url, text: data.name });

                                cartInfo.append(productImage, productLink);

                                var cartPrice = $("<div>", { class: "cart-preview-price" });
                                var priceSpan = $("<span>").append(
                                    $("<span>").text(data.price)
                                );
                                var countSpan = $("<span>", { style: "color:#888;" }).append(
                                    $("<span>").text(data.count)
                                );

                                cartPrice.append(priceSpan, countSpan);
                                cartItem.append(cartInfo, cartPrice);

                                cartItemsContainer.append(cartItem);
                            });
                        }
                    });

                    if (typeof dataLayer !== 'undefined') {
                        gtag('event', 'add_to_cart', {
                            currency: form.data('currency'),
                            value: Number(form.find('input[name="goodPcs"]').val()) * form.data('price'),
                            items: [
                                {
                                    item_id: form.data('good_id').toString(),
                                    item_name: form.data('name'),
                                    price: form.data('price'),
                                    item_brand: form.data('brand'),
                                    item_category: form.data('category'),
                                    index: 0,
                                    discount: form.data('discount'),
                                    quantity: Number(form.find('input[name="goodPcs"]').val())
                                }
                            ]
                        });
                        // dataLayer.push({
                        //     'event' : 'addToCart',
                        //     'ecommerce': {
                        //         'add': {
                        //             'products': [{
                        //                 'id': form.data('id'),
                        //                 'name': form.data('name'),
                        //                 'price': form.data('price'),
                        //                 'brand': form.data('brand'),
                        //                 'category': form.data('category'),
                        //                 'quantity': form.find('input.goodPcs').val()
                        //             }]
                        //         }
                        //     },
                        //     'eventCallback': function() {
                        //     }
                        // });
                    }

                    $('.popupDialog', popup).each(function(){
                        let dialogUi = $(this);
                        dialogUi.popupDialog({
                            create: function(dialog) {
                                dialog.parent().css("z-index", getHighestZIndex()+1);
                            },
                            reloadOnSuccess: false,
                            success: function (dialog) {
                                let img = $('img', dialogUi);
                                if(dialogUi.attr('data-inshoppinglist') === '0') {
                                    img.attr('alt', __("Odobrať zo zoznamu"));
                                    img.attr('src', __("/public/src/img/add-to-favourite-active.svg"));
                                    dialogUi.attr('title', __("Odobrať zo zoznamu"));
                                    dialogUi.attr('data-inshoppinglist', '1');
                                    dialogUi.attr('href', dialogUi.attr('href').replace('remove=0', 'remove=1'));
                                } else {
                                    img.attr('alt', __("Pridať do zoznamu"));
                                    img.attr('src', __("/public/src/img/add-to-favourite-gray.svg"));
                                    dialogUi.attr('title', __("Pridať do zoznamu"));
                                    dialogUi.attr('data-inshoppinglist', '0');
                                    dialogUi.attr('href', dialogUi.attr('href').replace('remove=1', 'remove=0'));
                                }

                            }
                        });
                    });

                    // zavolame success function
                    params.success(form);
                }
            },
            error: function(){
                report(__('Produkt sa nepodarilo pridať do košíka'), 'ERROR');
            },
            complete: function(){

                // zavolame complete function
                params.complete();
            }
        });
    });

    return this;
};

jQuery.fn.rangeSlider = function(settings){

    settings = $.extend({
        inputMinName: 'min',
        inputMaxName: 'max',
        inputMinSelector: '.input-min',
        inputMaxSelector: '.input-max',
        min: 0,
        max: 1000,
        minValue: '',
        maxValue: '',
        round: true,
        unit: '',
        sliderSelector: '.range-slider',
        valuesSelector: '.range-values',
        floatingValues: true,
        minValueSelector: '.range-min-value',
        maxValueSelector: '.range-max-value',
        onCreate: function(instance){},
        onStop: function(instance){},
        onChangeCustom: function(instance){},
        display: function(instance){
            var $this = $(instance);

            var min = $this.find(settings.minValueSelector).text(instance.minValue + instance.unit);
            var max = $this.find(settings.maxValueSelector).text(instance.maxValue + instance.unit);

            if(settings.floatingValues){
                $this.find(settings.valuesSelector).css('position', 'relative');
                window.setTimeout(function(){
                    min.css({
                        position: 'absolute',
                        left: ((instance.minValue - instance.min) / (instance.max - instance.min) * 100) + '%',
                        marginLeft: -min.width() / 2
                    });
                    max.css({
                        position: 'absolute',
                        left: ((instance.maxValue - instance.min) / (instance.max - instance.min) * 100) + '%',
                        marginLeft: -max.width() / 2
                    });
                }, 0);
            }
        }
    }, settings);

    return this.each(function(){

        var $this = $(this);
        var self = this;

        self.min = settings.min;
        self.max = settings.max;
        self.minValue = settings.minValue;
        self.maxValue = settings.maxValue;
        self.unit = settings.unit;

        self.init = function(){

            if($this.data('min') !== undefined){
                self.min = $this.data('min');
            }
            if($this.data('max') !== undefined){
                self.max = $this.data('max');
            }
            if($this.data('minvalue') !== undefined){
                self.minValue = $this.data('minvalue');
            }
            if($this.data('maxvalue') !== undefined){
                self.maxValue = $this.data('maxvalue');
            }
            if($this.data('unit') !== undefined){
                self.unit = $this.data('unit');
            }

            // zaokruhlime na desiatky
            if (settings.round) {
                self.min = Math.floor(self.min / 10) * 10;
                self.max = Math.ceil(self.max / 10) * 10;
            }

            // ak nemáme štruktúru vygnernovanú v html tak ju dogenerujeme
            if($this.html() == ''){
                $this.html(
                    '<div class="' + settings.sliderSelector.substring(1) + '"></div>' +
                    '<input class="' + settings.inputMinSelector.substring(1) + '" type="hidden" value="' + self.minValue + '" name="' + settings.inputMinName + '" />' +
                    '<input class="' + settings.inputMaxSelector.substring(1) + '" type="hidden" value="' + self.maxValue + '" name="' + settings.inputMaxName + '" />' +
                    '<div class="' + settings.valuesSelector.substring(1) + '">' +
                        '<span class="' + settings.minValueSelector.substring(1) + '"></span>' +
                        '<span class="' + settings.maxValueSelector.substring(1) + '"></span>' +
                    '</div>' +
                    '<div class="' + settings.valuesSelector.substring(1) + '-custom' + '">' +
                        '<span class="' + settings.minValueSelector.substring(1) + '-custom' + '">' +
                            __('OD - DO') + '<br />' +
                            '<input class="text min-custom' + '" type="text" value="' + self.minValue + '" />' +
                            ' - ' +
                            '<input class="text max-custom' + '" type="text" value="' + self.maxValue + '" />' +
                        '</span>' +
                    '</div>'
                );
            }

            self.slider = $this.find(settings.sliderSelector).slider({
                range: true,
                min: self.min,
                max: self.max,
                values: [self.minValue || self.min, self.maxValue || self.max],
                create: function () {
                    if ($.isFunction(settings.onCreate)) {
                        settings.onCreate(self);
                    }
                },
                slide: function(event, ui) {
                    self.display(ui.values[0], ui.values[1]);
                    $this.find(settings.inputMinSelector).val(ui.values[0] <= self.min ? '' : ui.values[0]);
                    $this.find(settings.inputMaxSelector).val(ui.values[1] >= self.max ? '' : ui.values[1]);
                },
                stop: function () {
                    if ($.isFunction(settings.onStop)) {
                        settings.onStop(self);
                    }
                }
            });

            $('.min-custom', $this).on('change', function() {
                $('.' + settings.inputMinSelector.substring(1), $this).val($(this).val());
                if ($.isFunction(settings.onChangeCustom)) {
                    settings.onChangeCustom(self.slider);
                }
            });

            $('.max-custom', $this).on('change', function() {
                $('.' + settings.inputMaxSelector.substring(1), $this).val($(this).val());
                if ($.isFunction(settings.onChangeCustom)) {
                    settings.onChangeCustom(self.slider);
                }
            });

            self.display(self.slider.slider("values", 0), self.slider.slider("values", 1));
        };

        self.display = function(min, max){
            self.minValue = min;
            self.maxValue = max;
            if ($.isFunction(settings.display)) {
                settings.display(self);
            }
        };

        $this.on('visible', function(){
            settings.display(self);
        });

        self.init();
    });
};

jQuery.fn.valueSlider = function(settings){

    settings = $.extend({
        inputName: 'value',
        inputSelector: '.input',
        min: 0,
        max: 1000,
        val: '',
        unit: '',
        sliderSelector: '.range-slider',
        valuesSelector: '.range-values',
        floatingValues: true,
        valueSelector: '.range-value',
        onCreate: function(instance){},
        onStop: function(instance){},
        display: function(instance){
            var $this = $(instance);

            var value = $this.find(settings.valueSelector).text(instance.val + instance.unit);
            if(settings.floatingValues){
                $this.find(settings.valuesSelector).css('position', 'relative');
                window.setTimeout(function(){
                    value.css({
                        position: 'absolute',
                        left: ((instance.val - instance.min) / (instance.max - instance.min) * 100) + '%',
                        marginLeft: -value.width() / 2
                    });

                }, 0);
            }
        }
    }, settings);

    return this.each(function(){

        var $this = $(this);
        var self = this;

        self.min  = settings.min;
        self.max  = settings.max;
        self.val  = settings.val;
        self.unit = settings.unit;

        self.init = function(){

            if($this.data('min') !== undefined){
                self.min = $this.data('min');
            }
            if($this.data('max') !== undefined){
                self.max = $this.data('max');
            }
            if($this.data('value') !== undefined){
                self.val = $this.data('value');
            }
            if($this.data('unit') !== undefined){
                self.unit = $this.data('unit');
            }

            // ak nemáme štruktúru vygnernovanú v html tak ju dogenerujeme
            if($this.html() == ''){
                $this.html(
                    '<div class="' + settings.sliderSelector.substring(1) + '"></div>' +
                    '<input class="' + settings.inputSelector.substring(1) + '" type="hidden" value="' + self.val + '" name="' + settings.inputName + '">' +
                    '<div class="' + settings.valuesSelector.substring(1) + '">' +
                    '<span class="' + settings.valueSelector.substring(1) + '"></span>' +
                    '<span class="min">' + self.min + '</span>' +
                    '<span class="max">' + self.max + '</span>' +
                    '</div>'
                );
            }

            self.slider = $this.find(settings.sliderSelector).slider({
                min: self.min,
                max: self.max,
                value: self.val,
                create: function () {
                    if ($.isFunction(settings.onCreate)) {
                        settings.onCreate(self);
                    }
                },
                slide: function(event, ui) {
                    self.display(ui.value);
                    $this.find(settings.inputSelector).val(ui.value);
                },
                stop: function () {
                    if ($.isFunction(settings.onStop)) {
                        settings.onStop(self);
                    }
                }
            });

            self.display(self.slider.slider("value"));
        };

        self.display = function(value){
            self.val = value;
            if ($.isFunction(settings.display)) {
                settings.display(self);
            }
        };

        $this.on('visible', function(){
            settings.display(self);
        });

        self.init();
    });
};

jQuery.fn.hoverAttribs = function () {
    return this.each(function () {
        var self = jQuery(this);

        self.hover(function (e) {
            var previewId = self.attr('id') + '_preview';
            var preview = $('#' + previewId);
            if (preview.length == 0) {
                preview = $('<div class="productAttribPicturePreview"></div>');
                preview.attr('id', previewId);
                img = $('<img />');
                img.attr('src', self.attr('rel'));
                img.appendTo(preview);

                p = $('<p></p>');
                p.html(self.find('img').attr('alt'));
                p.appendTo(preview);

                var top = e.pageY + 20;
                var left = e.pageX + 20;
                if(left + preview.outerWidth() > $(window).width()){
                    left = left - preview.outerWidth() - 20;
                }

                preview.appendTo($('body'));
                preview.css({
                    top: top + 'px',
                    left: left + 'px'
                });
            } else {
                preview.show();
            }
        }, function () {
            $('#' + this.id + '_preview').hide();
        }).mousemove(function (e) {
            var preview = $('#' + this.id + '_preview');
            var top = e.pageY + 20;
            var left = e.pageX + 20;
            if(left + preview.outerWidth() > $(window).width()){
                left = left - preview.outerWidth() - 20;
            }

            if (preview.length) {
                preview.css({
                    top: top + 'px',
                    left: left + 'px'
                });
            }
        }).click(function () {
            return false;
        });
    });
};
